export default __webpack_public_path__ + "static/media/history.690c1b62.jpg";